import getLocaleFromCountry from './get-locale-from-country';
import getMatchedCountry from './get-matched-country';
import getSplitLocale from './get-split-locale';
import getValidatedCountryCode from './get-validated-country-code';
import getValidatedLocale from './get-validated-locale';

/**
 * Check valid country-locale preference
 * if country and locale mismatch or if no locale, get new locale from country.
 * Note that validation is done by validation fns comparing against lib-locale
 * array locales, which is array of country objects e.g.
 * [{
 *  name: 'locale.country.Argentina',
 *  iso_code: '032',
 *  code: 'AR',
 *  languages: [
 *    {
 *      name: 'Español',
 *      code: 'es'
 *    }
 *  ]
 *},...]
 * @param {string} countryCode e.g. "US"
 * @param {string} locale e.g. "en_US"
 * @return {string|undefined} locale or undefined
 */
export const getValidCountryLocale = (countryCode, locale) => {
  const validatedCountyCode = getValidatedCountryCode(countryCode);
  const validatedLocale = getValidatedLocale(locale);

  let country;

  if (validatedCountyCode) {
    country = getMatchedCountry(validatedCountyCode);
  }

  if (country && validatedLocale) {
    const localeCountryCode = getSplitLocale(validatedLocale)[1];
    // if locale country matches countryCode, valid locale, else get new locale from countryCode
    if (localeCountryCode === validatedCountyCode) {
      return validatedLocale;
    }
    return getLocaleFromCountry(country);
  } else if (validatedCountyCode && !validatedLocale) {
    return getLocaleFromCountry(country);
  } else if (validatedLocale) {
    return validatedLocale;
  }

  return undefined;
};

/**
 * F16964 Creates dpaLocale string. Take locale in following priority:
 * -- 1 User cookie country_preference/locale
 * -- 2 vInit country/locale
 * -- 3 Browser locale
 * -- 4 default en_US
 * @param {object} configs
 * @return {string} dpaLocale
 */
const getCountryLocalePreference = configs => {
  const defaultLocale = 'en_US';

  const cCountryCode = getValidatedCountryCode(configs.cookieCountry);
  const cLocale = getValidatedLocale(configs.cookieLocale);
  const vCountryCode = getValidatedCountryCode(configs.vInitRequest.countryCode);
  const vLocale = getValidatedLocale(configs.vInitRequest.locale);
  const bLocale = getValidatedLocale(configs.vInitRequest.browserLocale);

  if (cCountryCode || cLocale) {
    return getValidCountryLocale(cCountryCode, cLocale);
  } else if (vCountryCode || vLocale) {
    return getValidCountryLocale(vCountryCode, vLocale);
  } else if (bLocale) {
    return getValidCountryLocale('', bLocale);
  }

  //If all above conditions fails, we will default to en_US.
  return defaultLocale;
};

export default getCountryLocalePreference;
